import React from 'react';

// Italian Privacy Policy section bodies (binding version), moved verbatim
// from PrivacyPolicy.jsx. Keys match the `privacy.sections.*` locale keys.
const privacyIt = {
  dataCollected: (
    <>
            Raccogliamo i dati del tuo account (email, tramite Firebase Authentication), il contenuto delle
            tue sessioni di brainstorming col mentor AI, e — solo se scegli esplicitamente di inviarla a
            fine sessione — una richiesta di contatto (email, ed eventualmente un numero di telefono se lo
            fornisci). Se durante una sessione emerge chiaramente un problema di business che stai
            esplorando, un estratto anonimo e riassunto (mai il tuo nome, mai il nome della tua azienda) può
            essere mostrato, dopo revisione manuale, nella sezione "casi d'uso" della home page.
    </>
  ),
  legalBasis: (
    <>
            Il trattamento dei dati dell'account e delle sessioni si basa sull'esecuzione del servizio che
            hai richiesto. L'invio di una richiesta di contatto si basa sul tuo consenso esplicito, dato
            spuntando la casella di consenso al momento dell'invio — puoi scegliere di non inviarla in
            qualsiasi momento.
    </>
  ),
  retention: (
    <>
            I dati dell'account e delle sessioni sono conservati finché il tuo account resta attivo. Le
            richieste di contatto sono conservate per un massimo di 6 mesi, dopodiché vengono cancellate
            automaticamente. I casi d'uso pubblicati in home page sono anonimi fin dall'origine e non hanno
            un limite di conservazione legato a te personalmente.
    </>
  ),
  thirdParties: (
    <>
            Quando invii una richiesta di contatto, il tuo nome (se disponibile) e la tua email vengono
            inviati come notifica interna a Telegram, per avvisare il team che qualcuno ha chiesto di essere
            ricontattato — il numero di telefono, se fornito, NON viene mai inviato a Telegram e resta solo
            nei nostri sistemi.
            <br /><br />
            <strong>Google Analytics 4.</strong> Se presti il consenso tramite il banner cookie (categoria
            "Statistiche"), usiamo Google Analytics 4 (ID <code>G-FXG3L4ZPD9</code>) per raccogliere statistiche
            sull'uso del sito. La base giuridica è il tuo consenso (art. 6.1.a GDPR; art. 122 Codice Privacy).
            Google Ireland Ltd / Google LLC trattano i dati quali responsabili del trattamento per nostro conto,
            con trasferimento dei dati negli Stati Uniti nell'ambito dell'EU-US Data Privacy Framework e, dove
            applicabile, delle Clausole Contrattuali Tipo. Puoi
            revocare il consenso in qualsiasi momento dal link "Preferenze cookie" nel footer del sito. Per i
            dettagli (cookie usati, durata) consulta la{' '}
            <a href="/cookie-policy">Cookie Policy</a>.
    </>
  ),
  yourRights: (
    <>
            Puoi richiedere l'accesso, la correzione o la cancellazione anticipata dei tuoi dati scrivendo a{' '}
            <a href="mailto:info@fluel.it">info@fluel.it</a>.
    </>
  ),
};

export default privacyIt;
